import messages from 'lang'
import { IntlShape } from 'react-intl'

// TODO refactor this out. This should allow any i18n key, no whitelist/mapping
export type TooltipNameType =
  | 'trade_ticket.limit'
  | 'trade_ticket.market'
  | 'trade_ticket.fillorkill'
  | 'trade_ticket.goodtilcancelled'
  | 'trade_ticket.goodtildate'
  | 'trade_ticket.immediateorcancel'
  | 'trade_ticket.stop'
  | 'trade_ticket.stoplimit'
  | 'ticket_field.amount'
  | 'ticket_field.limitprice'
  | 'ticket_field.triggerpricestop'
  | 'ticket_field.triggerpricestoplimit'
  | 'ticket_field.limitpricestoplimit'
  | 'ticket_field.min_amt'
  | 'ticket_field.postonly'
  | 'orderbook.amount'
  | 'orderbook.total'
  | 'orderbook.price'
  | 'trades.time'
  | 'trades.amount'
  | 'trades.price'
  | 'estimated.amount'
  | 'leverage_ratio_tooltip'
  | 'collateral_tooltip'
  | 'mark_price_tooltip'
  | 'collateral_edit_amount'
  | 'margin_adjusted_margin_tooltip'
  | 'margin_disabled_side'
  | 'order_confirmation.amount'

const selectTooltip = (name: TooltipNameType, intl: IntlShape, rest): string => {
  switch (name) {
    case 'trade_ticket.limit':
      return intl.formatMessage(messages.tooltip_trade_ticket_limit)
    case 'trade_ticket.market':
      return intl.formatMessage(messages.tooltip_trade_ticket_market)
    case 'trade_ticket.fillorkill':
      return intl.formatMessage(messages.tooltip_trade_ticket_fillorkill)
    case 'trade_ticket.goodtilcancelled':
      return intl.formatMessage(messages.tooltip_trade_ticket_goodtilcancelled)
    case 'trade_ticket.goodtildate':
      return intl.formatMessage(messages.tooltip_trade_ticket_goodtildate)
    case 'trade_ticket.immediateorcancel':
      return intl.formatMessage(messages.tooltip_trade_ticket_immediateorcancel)
    case 'trade_ticket.stop':
      return intl.formatMessage(messages.tooltip_trade_ticket_stop)
    case 'trade_ticket.stoplimit':
      return intl.formatMessage(messages.tooltip_trade_ticket_stoplimit)
    case 'ticket_field.amount':
      return intl.formatMessage(messages.tooltip_ticket_field_amount)
    case 'ticket_field.limitprice':
      return intl.formatMessage(messages.tooltip_ticket_field_limitprice)
    case 'ticket_field.min_amt':
      return intl.formatMessage(messages.tooltip_ticket_field_min_amt)
    case 'ticket_field.triggerpricestop':
      return intl.formatMessage(messages.tooltip_ticket_field_triggerpricestop)
    case 'ticket_field.triggerpricestoplimit':
      return intl.formatMessage(messages.tooltip_ticket_field_triggerpricestoplimit)
    case 'ticket_field.limitpricestoplimit':
      return intl.formatMessage(messages.tooltip_ticket_field_limitpricestoplimit)
    case 'ticket_field.postonly':
      return intl.formatMessage(messages.tooltip_ticket_field_postonly)
    case 'orderbook.amount':
      return intl.formatMessage(messages.tooltip_orderbook_amount)
    case 'orderbook.price':
      return intl.formatMessage(messages.tooltip_orderbook_price)
    case 'orderbook.total':
      return intl.formatMessage(messages.tooltip_orderbook_total)
    case 'trades.amount':
      return intl.formatMessage(messages.tooltip_trades_amount)
    case 'trades.time':
      return intl.formatMessage(messages.tooltip_trades_time)
    case 'trades.price':
      return intl.formatMessage(messages.tooltip_trades_price)
    case 'estimated.amount':
      return intl.formatMessage(messages.tooltip_estimated_amount)
    case 'order_confirmation.amount':
      return intl.formatMessage(messages.tooltip_order_confirmation_amount)
    default:
      return intl.formatMessage(messages[name], rest)
  }
}

export default selectTooltip
